import script from "./add-aggregates.vue?vue&type=script&setup=true&lang=js"
export * from "./add-aggregates.vue?vue&type=script&setup=true&lang=js"

import "./add-aggregates.vue?vue&type=style&index=0&id=e7a4cadc&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7a4cadc"]])

export default __exports__